import { isPromise } from "../fn";
import pipe from "../fn/pipe";

export const after = fn => value => (isPromise(value) ? value.then(fn) : fn(value));

const then = handler => fn => {
	if (typeof handler !== "function") return fn;
	return (...args) =>
		pipe(
			fn(...args),
			after(res => handler(res, ...args)),
		);
};

export default then;
